
// Use native fetch in browser (node-fetch not needed for client-side)
const fetch = typeof window !== 'undefined' ? window.fetch.bind(window) : null
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

import ApolloClient from 'apollo-client'
import gql from 'graphql-tag'

class GameApi {
  constructor (request) {
    this.initApolloClient()
  }
  set request (request) {
    this._request = request
  }
  initApolloClient () {
    const isBrowser = typeof window !== 'undefined'

    const customFetch = (uri, options) => {
      // if this.request we are in SSR and need to pass cookies from the
      // original request
      if (this._request) {
        options.headers.cookie = this._request.headers.cookie
      }

      return fetch(uri, options)
    }

    const client = new ApolloClient({
      link: createHttpLink({
        uri: this.getBaseUrl() + '/gql',
        credentials: 'include',
        fetch: customFetch
      }),
      ssrMode: !isBrowser,
      onError: (e) => {
        console.warn(e)
      },
      cache: new InMemoryCache(),
      defaultOptions: {
        query: {
          fetchPolicy: 'network-only'
        }
      }
    })

    // @todo pablo - 2020-02-20 : create a getter so we can assure to return a
    // new client in SSR for every request, to assure we dont have any shared
    // data between request from different users
    this.apollo = {
      uri: this.getBaseUrl() + '/gql',
      query: async (request) => {
        let data = null
        try {
          data = await client.query(request)
        } catch (e) {
          console.warn(e)
          throw e
        }
        return data
      },
      mutate: async (request) => {
        let data = null
        try {
          data = await client.mutate(request)
        } catch (e) {
          console.warn(e)
          throw e
        }
        return data
      }
    }
  }

  getBaseUrl () {
    if (process.env.NODE_ENV === 'development') {
      const host = process.client
        ? window.location.hostname
        : 'localhost'

      return `http://${host}:3388`
    }

    return 'https://api.thevortex.io'
  }

  async ranking () {
    return (await this.apollo.query({
      query: gql`{
        ranking {
          user {
            _id
            alias
            avatar
          }
          gold
        }
      }`
    })).data.ranking
  }

  async loadMyStarship () {
    return (await this.apollo.query({
      variables: { },
      query: gql`{
        loadMyStarship {
          _id
          type
          data
        }
      }`
    })).data.loadMyStarship
  }

  async loadBoard (id) {
    return (await this.apollo.query({
      variables: { id: id },
      query: gql`query ($id: ID!) {
        loadBoard (id : $id) {
          _id
          type
          data
        }
      }`
    })).data.loadBoard
  }

  async saveBoard (id, data) {
    return (await this.apollo.mutate({
      variables: { id, data },
      mutation: gql`mutation ($id: ID!, $data: String!) {
        saveBoard (id: $id, data: $data) {
          _id
          type
          data
        }
      }`
    })).data.saveMyStarship
  }
}

export default new GameApi()



// WEBPACK FOOTER //
// ./src/plugins/GameApi.js